import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import kondoLogo from '../../assets/Kondify letra negra sin fondo.png';

/**
 * Premium Sticky Brand Header
 * Renders the new purple pin icon and "Kondo" wordmark in black.
 */
const KondoBrandHeader = ({ showBack = false, isFixedWeb = false, onBackClick }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate('/');
    }
  };

  return (
    <div className={`ks-mobile-header-group ${isFixedWeb ? 'ks-header-fixed-all' : ''}`}>
      <div className="native-safe-area-top" />
      <div className="kondo-sticky-header-stitch">
        <div className="kondo-brand-row-stitch">
          {showBack && (
            <button
              onClick={handleBack}
              className="brand-back-btn-stitch"
              aria-label="Volver"
            >
              <IoArrowBack size={20} />
            </button>
          )}
          <img
            src={kondoLogo}
            alt="Kondify"
            className="kondify-full-logo-header"
            style={{
              height: '60px',
              width: 'auto',
              marginTop: '-12px',
              marginBottom: '-12px'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default KondoBrandHeader;
